import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

import Dropdown from '../../../components/react/Dropdown';
import Pagination from '../../../components/react/Pagination';
import FacetList from './FacetList';

import { setTrackDataLayer, getQueryParams } from '../../../utils/index';

const ProductsTab = ({
  page,
  sort,
  filters,
  tab,
  resultsInfo,
  resultsListing,
  sortOptions,
  currentPage,
  resultsPerPage,
  totalPages,
  facets,
  selectedTab,
  loading,
  setPage,
  setSort,
  setFilters
}) => {

  const handleFilters = filter => {
    const selectedFacets = { ...filters };
    selectedFacets[filter.name] = filter.options;

    setFilters(selectedFacets);

    if (!tab && !selectedTab) return;
    if (tab.value === selectedTab.value) {
      const gaItems = resultsListing.map(item => item.gaModel);

      setTrackDataLayer({
        eventName: 'view_item_list',
        custom: {
          ecommerce: {
            items: gaItems
          }
        }
      });
    }
  };

  const handleDataLayer = e => {
    e.preventDefault();
    const href = e.target.closest('a').href;
    if (href) {
      setTrackDataLayer({
        eventName: 'search_bar_navigations',
        custom: {
          search_term: getQueryParams(),
          landing_page: href
        }
      });

      window.location.href = href;
    }
  };

  return (
    <>
      <div
        className={
          tab.value === selectedTab.value
            ? 'search-results__tab-content search-results__tab-content--products active'
            : 'search-results__tab-content search-results__tab-content--products'
        }
        tabIndex={tab.value === selectedTab.value ? 0 : -1}
        role="tabpanel"
        aria-labelledby={tab.label}
      >
        {loading && !resultsListing ? (
          <div className="results-listing__loading"></div>
        ) : (
          <>
            <div className="search-results__info-sort-container">
              <div className="search-results__info-copy">
                {resultsInfo && parse(resultsInfo)}
              </div>
              {!!sortOptions && (
                <div className="search-results__dropdown-container">
                  <Dropdown
                    options={sortOptions}
                    onChange={sort => setSort(sort.value)}
                    selectedOption={
                      sort
                        ? sortOptions.find(opt => {
                          if (opt.value === sort) {
                            return opt.value;
                          } else if (opt.selected) {
                            return opt.value;
                          }
                        })
                        : sortOptions[0]
                    }
                  />
                </div>
              )}
            </div>
            {resultsListing.length > 0 && (
              <div className="search-results__inner-tab-content">
                {facets && (
                  <FacetList
                    facets={facets}
                    selectedFacets={filters}
                    onFiltersChange={handleFilters}
                  />
                )}
                <div className="search-results__container">
                  <div className="search-results__listing">
                    {resultsListing.map((item, index) => (
                      <div key={index} className="search-results__item">
                        {item.imageUrl && !item.link && (
                          <img src={item.imageUrl} />
                        )}
                        {item.imageUrl && item.link && (
                          <a href={item.link} onClick={e => handleDataLayer(e)}>
                            <img src={item.imageUrl} />
                          </a>
                        )}
                        {item.badgeLabel && (
                          <span className="badge">
                            <span>{item.badgeLabel}</span>
                          </span>
                        )}
                        <div className="search-results__item-info">
                          {item.link ? (
                            <a href={item.link} onClick={e => handleDataLayer(e)}>
                              <h3 className="search-results__item-title">
                                {parse(item.title)}
                              </h3>
                            </a>
                          ) : (
                            <h3 className="search-results__item-title">
                              {parse(item.title)}
                            </h3>
                          )}
                          <div className="search-results__item-copy rtf">
                            {item.copy ? parse(item.copy) : null}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  {!!totalPages && (
                    <Pagination
                      currentPage={page ? Number(page) : Number(currentPage)}
                      totalPages={totalPages && totalPages}
                      onNavigate={setPage}
                      resultsPerPage={resultsPerPage}
                      resultsListing={resultsListing}
                      tab={tab}
                      selectedTab={selectedTab}
                    />
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

ProductsTab.propTypes = {
  facets: PropTypes.array,
  subTitle: PropTypes.string,
  resetBtnLabel: PropTypes.string
};

export default ProductsTab;
